import React, { useState } from 'react'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import {
  getTimezoneAbbreviation,
  getFirstDayMonthOfWeek,
  getLastDayMonthOfWeek,
  getSingleDateFormat
} from 'srcReact/helpers/datetimeHelper'

const Toolbar = (props) => {
  const { t } = useTranslation()
  const timezone = useSelector((state) => state.calendarEvents.timezone)
  const [selectedOption] = useState({
    value: props.view,
    label: t(`calendar_page.dropdown.${props.view}`)
  })

  const getCustomToolbar = () => {
    const goToBack = () => {
      let view = props.view
      let mDate = props.date
      let newDate
      if (view === 'month') {
        newDate = new Date(mDate.getFullYear(), mDate.getMonth() - 1, 1)
      } else if (view === 'week') {
        newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() - 7, 1)
      } else {
        newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() - 1, 1)
      }
      props.onNavigate('prev', newDate)
    }

    const goToNext = () => {
      let view = props.view
      let mDate = props.date
      let newDate
      if (view === 'month') {
        newDate = new Date(mDate.getFullYear(), mDate.getMonth() + 1, 1)
      } else if (view === 'week') {
        newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() + 7, 1)
      } else {
        newDate = new Date(mDate.getFullYear(), mDate.getMonth(), mDate.getDate() + 1, 1)
      }
      props.onNavigate('next', newDate)
    }

    const month = () => {
      const date = dayjs(props.date)
      let month = date.format('MMMM')

      return (
        <span className={`${'rbc-toolbar-label rbc-date'} ${styles.rbcToolbarLabel}`}>
          <span> {`${month}`}</span>
        </span>
      )
    }

    const week = () => {
      return (
        <span className={`${'rbc-toolbar-label rbc-date'} ${styles.rbcToolbarLabel}`}>
          <span
            className={styles.highlighted}
            dangerouslySetInnerHTML={{ __html: getFirstDayMonthOfWeek(props.date) }}
          />
          <span>{' - '}</span>
          <span
            className={styles.highlighted}
            dangerouslySetInnerHTML={{ __html: getLastDayMonthOfWeek(props.date) }}
          />
        </span>
      )
    }

    const day = () => {
      return (
        <span className={`${'rbc-toolbar-label rbc-date'} ${styles.rbcToolbarLabel}`}>
          <span className={styles.highlighted} dangerouslySetInnerHTML={{ __html: getSingleDateFormat(props.date) }} />
        </span>
      )
    }

    const options = [
      { value: 'day', label: t('calendar_page.dropdown.day') },
      { value: 'week', label: t('calendar_page.dropdown.week') },
      { value: 'month', label: t('calendar_page.dropdown.month') }
    ]

    const handleSelect = (selected) => {
      props.onView(selected.value)
      props.handleCurrentView(selected.value)
      props.handleNavigate(props.date, selected.value)
    }

    return (
      <div className={`${'rbc-toolbar'} ${styles.rbcToolbar}`}>
        {props.view !== 'month' && <p className={styles.timezone}>{getTimezoneAbbreviation(new Date())}</p>}
        <div className={`${'rbc-toolbar-item-2'} ${styles.rbcToolbarItem}`}>
          <Dropdown1
            value={selectedOption}
            onChange={handleSelect}
            options={options}
            className={styles.dropdown}
            closeMenuOnSelect={true}
            isSearchable={false}
          />

          <span className={`${'rbc-btn-group'} ${styles.rbcBtnGroup}`}>
            <span className={styles.prevIcon} id='prev-btn-icon' onClick={goToBack}>
              <Icon name='chevron-left' alt='' />
            </span>

            {props.view === 'day' ? day() : props.view === 'month' ? month() : week()}

            <span className='next-icon' id='next-btn-icon' onClick={goToNext}>
              <Icon name='chevron-right' alt='' />
            </span>
          </span>
        </div>
      </div>
    )
  }

  return <React.Fragment>{getCustomToolbar()}</React.Fragment>
}

export default Toolbar
